/**
 * @generated SignedSource<<06881dfdc2b3e3160f1504d8f68b71e5>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type ApplicationReceivedQuery$variables = {
  slug: string;
};
export type ApplicationReceivedQuery$data = {
  readonly template: {
    readonly name: string;
    readonly version: {
      readonly data: any | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type ApplicationReceivedQuery = {
  response: ApplicationReceivedQuery$data;
  variables: ApplicationReceivedQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "slug"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "slug",
    "variableName": "slug"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "data",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ApplicationReceivedQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Template",
        "kind": "LinkedField",
        "name": "template",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "TemplateVersion",
            "kind": "LinkedField",
            "name": "version",
            "plural": false,
            "selections": [
              (v3/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ApplicationReceivedQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Template",
        "kind": "LinkedField",
        "name": "template",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "TemplateVersion",
            "kind": "LinkedField",
            "name": "version",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              (v4/*: any*/)
            ],
            "storageKey": null
          },
          (v4/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "224017e1ee5321d5e66a96216b5fdd2a",
    "id": null,
    "metadata": {},
    "name": "ApplicationReceivedQuery",
    "operationKind": "query",
    "text": "query ApplicationReceivedQuery(\n  $slug: String!\n) {\n  template(slug: $slug) {\n    name\n    version {\n      data\n      id\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "683b6a628b997758c13b0ea0984279e8";

export default node;
